const POPUP_STATUS = 'POPUP_STATUS'
const MENU_STATUS = 'MENU_STATUS'

const initState = {
  popupInfo: {
    type: '',
    status: false,
  }, //基本信息
  menuSelected: '' // 选中的菜单
}

// reducer
export function basicInfo(state = initState, action) {
  switch (action.type) {
    case POPUP_STATUS:
      return { ...state, popupInfo: action.popupInfo }
    case MENU_STATUS:
      return { ...state, menuSelected: action.menuSelected }
    default:
      return state
  }
}

// actions creater
function popupInfo(data) {
  return { type: POPUP_STATUS, popupInfo: data }
}

// actions creater
function menuStatus(data) {
  return { type: MENU_STATUS, menuSelected: data }
}

// 暴露方法
export function changePopup(param) {
  return (dispatch) => {
    dispatch(popupInfo(param))
  }
}

// 暴露方法
export function changeMenu(param) {
  return (dispatch) => {
    dispatch(menuStatus(param))
  }
}
